import React from "react";
import { Typography, Button } from "@mui/material";
import { NoMatchingRoundsContainer } from "../styled";

interface NoMatchingRoundsProps {
  handleViewMatchingRounds: () => void;
}

export const NoMatchingRounds: React.FC<NoMatchingRoundsProps> = ({ handleViewMatchingRounds }) => {
  return (
    <NoMatchingRoundsContainer>
      <Typography variant="h6" mb={1} sx={{ fontSize: '16px', fontWeight: 500 }}>
        No matching rounds eligible for export
      </Typography>
      <Typography variant="body1" mb={2} sx={{ fontSize: '14px', color: '#424242' }}>
        Matching Round has to be of a status Active (post matching) or Closed.
      </Typography>
      <Button
        variant="contained"
        onClick={handleViewMatchingRounds}
        sx={{
          bgcolor: '#2167e2',
          '&:hover': { bgcolor: '#1a52b3' },
          textTransform: 'none',
          fontWeight: 400,
          fontSize: '14px',
          padding: '6px 16px'
        }}
      >
        View Matching Rounds
      </Button>
    </NoMatchingRoundsContainer>
  );
};
